import eventBus from 'toxilibs/event_bus_queued.js'
import getUrlParams from 'toxilibs/url_params.js'

let log = {}


eventBus.on('user wants to start', function () {
    if (typeof localStorage.log === 'undefined') {
        reset()
    } else {
        log = JSON.parse(localStorage.log)
    }
})


function reset () {
    let {theme = 'basic_coding', token = '', returnUrl} = getUrlParams()

    log = {
        theme,
        history:  [],
        dateTime: Date.now(),
        token,
        returnUrl

        // seed:  // TODO: get random's seed
    }
}


function addEvent (event) {
    event.time = Math.round((Date.now() - log.dateTime) / 1000)
    log.history.push(event)

    localStorage.log = JSON.stringify(log)
}


export default {
    addEvent
}